import { EventEmitter, Injectable } from '@angular/core';
import { StepAnalyseEnum } from 'src/app/model/analyse-credit';
import { ETypeUser, TypePermissionEnum, User } from 'src/app/model/user';
import { isNotNullAndUndefined } from 'src/app/shared/helpers/utils';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  usuarioAutenticado = false;
  usuario: UserViewModel = null;

  mostrarMenuEmitter = new EventEmitter<boolean>();
  onUserChange = new EventEmitter<UserViewModel>();
  rotaAtual = new EventEmitter<string>();

  constructor() {}

  public usuarioEstaAutenticado(url: string): boolean {
    if (url.startsWith('/login')) {
      this.mostrarMenuEmitter.emit(false);
      return true;
    }
    this.rotaAtual.emit(url);

    if (this.usuario) {
      this.mostrarMenuEmitter.emit(true);
      return true;
    } else {
      this.mostrarMenuEmitter.emit(false);
      return false;
    }
  }

  public isPermissionCompany(companyId: string): boolean {
    // Verifica se o usuário tem premissão para a empresa
    return isNotNullAndUndefined(
      (this.usuario.permissions || []).find(
        (p) =>
          p.companyId === companyId && p.type !== TypePermissionEnum.VISUALIZAR
      )
    );
  }

  public isPermissionStep(companyId: string, step: StepAnalyseEnum): boolean {
    // Verifica se o usuário tem premissão para a empresa e tem cargo superior ou igual a step recebida
    return isNotNullAndUndefined(
      (this.usuario.permissions || []).find(
        (p) =>
          p.companyId === companyId &&
          Number(p.type) === Number(step) + 1 &&
          p.type !== TypePermissionEnum.VISUALIZAR
      )
    );
  }

  public findPermissionCompany(companyId: string): TypePermissionEnum {
    const perm = (this.usuario.permissions || []).find(
      (p) => p.companyId === companyId
    );
    return isNotNullAndUndefined(perm) ? perm.type : null;
  }

  public findPermissionsCompanyId(): Array<string> {
    return (this.usuario.permissions || []).map((p) => p.companyId);
  }

  public isPermissionAction(acoes: Array<string>): boolean {
    let acesso = false;
    acoes.forEach((acao) => {
      if (this.usuario.actions.includes(acao)) {
        acesso = true;
      }
    });
    return acesso;
  }
}

export class UserViewModel extends User {
  public actions: Array<String>;

  constructor(user: User) {
    super();
    this.username = user.username;
    this.password = user.password;
    this.name = user.name;
    this.email = user.email;
    this.active = user.active;
    this.alterPassword = user.alterPassword;
    this.permissions = user.permissions;
    this.actions = null;
    this.userAcceptanceTerm = null;
    this.typeUser = ETypeUser.FINAL_USER;
  }
}
